import React from 'react';
import { usePaywallContext } from '../../contexts/paywall';
import { closeMenu } from '../../state/app-state';
import { Account } from '../../services/models/account';
import { SubscriptionStatus } from '../../services/models/subscription';

interface UpsellSidebarNotificationProps {
  account: Account;
}

export function UpsellSidebarNotification(props: UpsellSidebarNotificationProps) {
  const { setPaywallModalShown } = usePaywallContext();

  const account = props.account;

  if (!account.subscription?.trial) {
    return null;
  }

  const trialExpired = account.subscription?.status === SubscriptionStatus.TrialExpired;
  const trialDaysLeft = account.subscription?.trialDaysLeft ?? 0;

  const handleUpsellClick = () => {
    closeMenu();
    setPaywallModalShown(true);
  };

  return (
    <div className="shrink-0 block w-full bg-gray-100 border-gray-200">
      <div className="px-3 my-5">
        <span className="block">
          {trialExpired && 'Your free trial has ended.'}
          {!trialExpired &&
            (trialDaysLeft > 0
              ? `Your free trial expires in ${trialDaysLeft} days.`
              : 'Enjoying your trial?')}
        </span>
        <span className="block">
          <button
            type={'button'}
            onClick={handleUpsellClick}
            className="text-secondary font-bold underline hover:text-secondary"
          >
            Upgrade now <span aria-hidden="true">&rarr;</span>
          </button>
        </span>
      </div>
    </div>
  );
}
